export interface Country {
  code: string
  name: string
  currency: string
  currencySymbol: string
}

export const COUNTRIES: Country[] = [
  { code: 'US', name: 'United States', currency: 'USD', currencySymbol: '$' },
  { code: 'CA', name: 'Canada', currency: 'CAD', currencySymbol: 'C$' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP', currencySymbol: '£' },
  { code: 'AU', name: 'Australia', currency: 'AUD', currencySymbol: 'A$' },
  { code: 'DE', name: 'Germany', currency: 'EUR', currencySymbol: '€' },
  { code: 'FR', name: 'France', currency: 'EUR', currencySymbol: '€' },
  { code: 'ES', name: 'Spain', currency: 'EUR', currencySymbol: '€' },
  { code: 'IT', name: 'Italy', currency: 'EUR', currencySymbol: '€' },
  { code: 'NL', name: 'Netherlands', currency: 'EUR', currencySymbol: '€' },
  { code: 'BE', name: 'Belgium', currency: 'EUR', currencySymbol: '€' },
  { code: 'SE', name: 'Sweden', currency: 'SEK', currencySymbol: 'kr' },
  { code: 'NO', name: 'Norway', currency: 'NOK', currencySymbol: 'kr' },
  { code: 'DK', name: 'Denmark', currency: 'DKK', currencySymbol: 'kr' },
  { code: 'CH', name: 'Switzerland', currency: 'CHF', currencySymbol: 'CHF' },
  { code: 'IE', name: 'Ireland', currency: 'EUR', currencySymbol: '€' },
  { code: 'NZ', name: 'New Zealand', currency: 'NZD', currencySymbol: 'NZ$' },
  { code: 'SG', name: 'Singapore', currency: 'SGD', currencySymbol: 'S$' },
  { code: 'JP', name: 'Japan', currency: 'JPY', currencySymbol: '¥' },
  { code: 'KR', name: 'South Korea', currency: 'KRW', currencySymbol: '₩' },
  { code: 'IN', name: 'India', currency: 'INR', currencySymbol: '₹' },
  { code: 'BR', name: 'Brazil', currency: 'BRL', currencySymbol: 'R$' },
  { code: 'MX', name: 'Mexico', currency: 'MXN', currencySymbol: 'MX$' },
  { code: 'ZA', name: 'South Africa', currency: 'ZAR', currencySymbol: 'R' },
]

export const getCountry = (code: string): Country | undefined => {
  return COUNTRIES.find(c => c.code === code)
}

export const getCurrencySymbol = (countryCode: string): string => {
  const country = getCountry(countryCode)
  return country?.currencySymbol || '$'
}
